import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

/**
 * Small badge shown only on the review account to differentiate
 * Growth Pack (OTO) features from Front-End features.
 */
export const GrowthPackBadge = ({ show }: { show: boolean }) => {
  if (!show) return null;
  return (
    <Badge className="text-[10px] px-1.5 py-0 h-5 gap-1 font-semibold bg-primary text-primary-foreground hover:bg-primary/90 border-0 shadow-sm">
      <Sparkles className="h-3 w-3" />
      Growth Pack
    </Badge>
  );
};
